import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-washington-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./washington-state-form.component.html",
  styleUrl: "./washington-state-form.component.scss",
})
export class WashingtonStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
